/**
 * Created by neo on 18.08.23
 */
import { makeAutoObservable } from 'mobx';
import { EventEntrySearchParams, SubscribedEventEntry, SubscribedEventEntryJson, createSubscribedEventEntry } from './SubscribedEventEntry';
import { HttpBackend } from '../../../Services/Http/HttpBackend';
import { FormField, FormFieldJson, createFormField } from '../../Explore/FormField';

export type SubscribedOfflineMeetingEventEntryJson = SubscribedEventEntryJson & {
  registrationFields: FormFieldJson[];
};

export type SubscribedOfflineMeetingEventEntry = SubscribedEventEntry & {
  registrationFields: FormField[];
  toJS(): SubscribedOfflineMeetingEventEntryJson;
  save(): Promise<SubscribedOfflineMeetingEventEntry>;
};

export function createSubscribedOfflineMeetingEventEntry(json?: Partial<SubscribedOfflineMeetingEventEntryJson>): SubscribedOfflineMeetingEventEntry {
  const base = createSubscribedEventEntry({ type: 'event.subscribed.offlineMeeting', ...json } as any);

  const entry: SubscribedOfflineMeetingEventEntry = makeAutoObservable({
    ...base,
    registrationFields: (json?.registrationFields ?? []).map((f) => createFormField(f)),

    toJS(): SubscribedOfflineMeetingEventEntryJson {
      return {
        ...base,
        registrationFields: this.registrationFields.map((f) => f),
      };
    },

    save(): Promise<SubscribedOfflineMeetingEventEntry> {
      return HttpBackend.post(`/coach/schedule/event/subscription`, this).then(() => this);
    },
  });

  return entry;
}

export const SubscribedOfflineMeetingEventEntryApi = {
  findExisting(params: EventEntrySearchParams): Promise<SubscribedOfflineMeetingEventEntry | undefined> {
    return HttpBackend.get('/coach/schedule/event/subscription', Object.assign(params, { size: 1 })).then((res) =>
      res[0] ? createSubscribedOfflineMeetingEventEntry(res[0]) : undefined,
    );
  },
};
